import script from "./AdvancedSettingsBtn.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdvancedSettingsBtn.vue?vue&type=script&setup=true&lang=ts"

import "./AdvancedSettingsBtn.vue?vue&type=style&index=0&id=554317d7&lang=scss"

const __exports__ = script;

export default __exports__